import firebase from 'firebase/index';
import {actionTypes} from 'redux-resource';

export default (resourceName, values) => {
	const now = new Date().toISOString();
	const {id, ...rest} = values;
	const data = {
		...rest,
		updatedAt: now
	};

	return dispatch => {
		dispatch({
			type: actionTypes.UPDATE_RESOURCES_PENDING,
			resourceName,
			request: 'update',
			resources: [id]
		});

		return firebase.database()
			.ref(`${resourceName}/${id}`)
			.update(data)
			.then(() => {
				const entity = {...data, id};

				dispatch({
					type: actionTypes.UPDATE_RESOURCES_SUCCEEDED,
					resourceName,
					request: 'update',
					resources: [entity]
				});

				return entity;
			});
	};
};



// WEBPACK FOOTER //
// ./src/client/redux/actions/helpers/update-item.js